module.exports = __webpack_public_path__ + "img/caracteristicas-moviles-digi-1.fde6c3a7.png";